import React, {useEffect} from "react";
import {connect} from 'react-redux';
import Box from '@mui/material/Box';
import { createMuiTheme, makeStyles } from "@material-ui/core/styles";
//import Container from 'react-bootstrap/Container';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
//import Paper from '@material-ui/core/Paper';
import Paper from '@mui/material/Paper';
import Card from '@material-ui/core/Card';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import PersonIcon from '@mui/icons-material/Person';
import HowToReg from '@mui/icons-material/HowToReg';
import AllInclusive from '@mui/icons-material/AllInclusive';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@mui/material/Typography';
import SvgIcon from '@mui/material/SvgIcon';
import TotalsChart from './TotalsChart';
//import MuiAlert from '@material-ui/lab/Alert';

//import Row from 'react-bootstrap/Row';
//import Col from 'react-bootstrap/Col';

import * as actions from '../store/actions/index';
//<path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
function HomeIcon(props) {
    return (
        <SvgIcon {...props}>
            <svg
                aria-hidden="true"
                data-prefix="fab"
                data-icon="github-alt"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 480 512"
            >
            <path
                fill="currentColor"
                d="M186.1 328.7c0 20.9-10.9 55.1-36.7 55.1s-36.7-34.2-36.7-55.1 10.9-55.1 36.7-55.1 36.7 34.2 36.7 55.1zM480 278.2c0 31.9-3.2 65.7-17.5 95-37.9 76.6-142.1 74.8-216.7 74.8-75.8 0-186.2 2.7-225.6-74.8-14.6-29-20.2-63.1-20.2-95 0-41.9 13.9-81.5 41.5-113.6-5.2-15.8-7.7-32.4-7.7-48.8 0-21.5 4.9-32.3 14.6-51.8 45.3 0 74.3 9 108.8 36 29-6.9 58.8-10 88.7-10 27 0 54.2 2.9 80.4 9.2 34-26.7 63-35.2 107.8-35.2 9.8 19.5 14.6 30.3 14.6 51.8 0 16.4-2.6 32.7-7.7 48.2 27.5 32.4 39 72.3 39 114.2zm-64.3 50.5c0-43.9-26.7-82.6-73.5-82.6-18.9 0-37 3.4-56 6-14.9 2.3-29.8 3.2-45.1 3.2-15.2 0-30.1-.9-45.1-3.2-18.7-2.6-37-6-56-6-46.8 0-73.5 38.7-73.5 82.6 0 87.8 80.4 101.3 150.4 101.3h48.2c70.3 0 150.6-13.4 150.6-101.3zm-82.6-55.1c-25.8 0-36.7 34.2-36.7 55.1s10.9 55.1 36.7 55.1 36.7-34.2 36.7-55.1-10.9-55.1-36.7-55.1z"
            />
            </svg>
        </SvgIcon>
    );
}

function TieIcon(props) {
    return (
        <SvgIcon {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                <path d="M352 128C352 198.7 294.7 256 224 256C153.3 256 96 198.7 96 128C96 57.31 153.3 0 224 0C294.7 0 352 57.31 352 128zM209.1 359.2L176 304H272L238.9 359.2L272.2 483.1L311.7 321.9C388.9 333.9 448 400.7 448 481.3C448 498.2 434.2 512 417.3 512H30.72C13.75 512 0 498.2 0 481.3C0 400.7 59.09 333.9 136.3 321.9L175.8 483.1L209.1 359.2z"/>
            </svg>
        </SvgIcon>
    );
}

function UsersIcon(props) {
    return (
        <SvgIcon {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                <path d="M319.9 320c57.41 0 103.1-46.56 103.1-104c0-57.44-46.54-104-103.1-104c-57.41 0-103.1 46.56-103.1 104C215.9 273.4 262.5 320 319.9 320zM369.9 352H270.1C191.6 352 128 411.7 128 485.3C128 500.1 140.7 512 156.4 512h327.2C499.3 512 512 500.1 512 485.3C512 411.7 448.4 352 369.9 352zM512 160c44.18 0 80-35.82 80-80S556.2 0 512 0c-44.18 0-80 35.82-80 80S467.8 160 512 160zM183.9 216c0-5.449 .9824-10.63 1.609-15.91C174.6 194.1 162.6 192 149.9 192H88.08C39.44 192 0 233.8 0 285.3C0 295.6 7.887 304 17.62 304h199.5C196.7 280.2 183.9 249.7 183.9 216zM128 160c44.18 0 80-35.82 80-80S172.2 0 128 0C83.82 0 48 35.82 48 80S83.82 160 128 160zM551.9 192h-61.84c-12.8 0-24.88 3.037-35.86 8.24C454.8 205.5 455.8 210.6 455.8 216c0 33.71-12.78 64.21-33.16 88h199.7C632.1 304 640 295.6 640 285.3C640 233.8 600.6 192 551.9 192z"/>
            </svg>
        </SvgIcon>
    )
}

function TrialIcon(props){
    return (
        <SvgIcon {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                <path d="M489.1 264.9C480.5 207.5 450.5 32 392.3 32c-14 0-26.58 5.875-37.08 14c-20.75 15.87-49.62 15.87-70.5 0C274.2 38 261.7 32 247.7 32c-58.25 0-88.27 175.5-97.77 232.9C188.7 277.5 243.7 288 319.1 288S451.2 277.5 489.1 264.9zM632.9 227.7c-6.125-4.125-14.2-3.51-19.7 1.49c-1 .875-101.3 90.77-293.1 90.77c-190.9 0-292.2-89.99-293.2-90.86c-5.5-4.875-13.71-5.508-19.71-1.383c-6.125 4.125-8.587 11.89-6.087 18.77C1.749 248.5 78.37 448 319.1 448s318.2-199.5 318.1-201.5C641.5 239.6 639 231.9 632.9 227.7z"/>
            </svg>
        </SvgIcon>
    )
}

function MinistraIcon(props){
    return (
        <SvgIcon {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.88 122.88">
                <path d="M17.89 0h88.9c8.85 0 16.1 7.24 16.1 16.1v90.68c0 8.85-7.24 16.1-16.1 16.1H16.1c-8.85 0-16.1-7.24-16.1-16.1v-88.9C0 8.05 8.05 0 17.89 0zm9.39 31.06h24.77l9.43 36.97 9.46-36.97H95.6v60.76H80.24V45.5L68.38 91.82H54.47L42.64 45.5v46.32H27.28V31.06z" fill-rule="evenodd" clip-rule="evenodd"/>
            </svg>
        </SvgIcon>
    )
}

const useStyles = makeStyles((theme) => ({
    paperCustom: {
      padding: "2rem",
      fontFamily: "roboto",
      margin: "2rem",
      minHeight: window.innerHeight,
      borderRadius: 0
    },
    typographyCustom: {
      marginBottom: "1rem"
    },
    dividerCustom: {
      marginTop: "2rem"
    },
    /* Custom */
    iconButtonMenu: {
      // backgroundColor: theme.palette.grey[300]
    }
  }));

function ResellerDashboard(props) {
    const classes = useStyles();
    useEffect(() => {
        console.log('logging dashboard reseller list');
        props.onGetSuperResellerList(props.token);
        props.onInitializeSaveMessage();
        props.onGetCountResellers(props.token);
        props.onGetCountDealers(props.token);
        props.onGetCountAllClients(props.token);
        props.onGetCountActiveClients(props.token);
        props.onGetCountExpiredClients(props.token);
        props.onGetCountTrials(props.token);
        props.onGetCountMinistra(props.token);
        props.onGetCountActiveTickets(props.token);
    }, []);

    //
    //<Grid item md={6} sm={12} xs={12}>
    //    <Paper elevation={5}>
    //        <Card>
    //            <CardContent>
    //                <Typography variant="h5" component="h5">
    //                    Unlimited
    //                </Typography>
    //                <Typography variant="subtitle1" color="textSecondary">
    //                    Credits Remaining
    //                </Typography>
    //            </CardContent>
    //        </Card>
    //    </Paper>
    //</Grid>
    //padding: '10px',
    // <div>
    //         <div className="lander">
    //             
    return (
        <Container maxWidth="xl">
            <Grid 
                container 
                spacing={1} 
                direction="col"
                justify="center"
                style={{ display: "flex" }}
                >
                    <Grid 
                        container 
                        spacing={2}
                        direction="row"
                        justify="center"
                        style={{ display: "flex" }}
                        >
                        <Grid item md={12}>
                        </Grid>
                        <Grid item xl={2} lg={2} md={3} sm={6} xs={12}>
                            <Paper
                                elevation={5}
                                sx={{
                                    height: '120px',
                                    marginBottom: '25px',
                                    overflow: 'hidden',
                                    display: 'block',
                                    position: 'relative',
                                    flexGrow: '1',
                                    color: '#fff',
                                    backgroundColor: '#2C3E50'
                                }}
                            >
                                <Box 
                                    component="div" 
                                    sx={{
                                        diplay: 'block', 
                                        width: '80px', 
                                        height: '80px',
                                        display: 'block',
                                        float: 'left',
                                        paddingLeft: '15px',
                                        paddingTop: '35px',
                                        marginBottom: '40px',
                                        fontSize: '35px',
                                        lineHeight: '35px'

                                        }}>
                                    <AttachMoneyIcon
                                        sx={{
                                            color: '#fff',
                                            opacity: '0.1',
                                            fontSize: '110px',
                                            marginLeft: '-35px',
                                            lineHeight: '110px'
                                        }}/>
                                </Box>
                                <Box component="div" sx={{
                                    display: 'block',
                                    position: 'absolute',
                                    right: '15px',
                                    paddingRight: '15px',

                                }}>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            paddingTop: '25px',
                                            textAlign: 'right',
                                            fontWeight: '300', 
                                            fontSize: '34px', 
                                            lineHeight: '36px',
                                            letterSpacing: '-1px',
                                            marginBottom: '0px',
                                            color: '#fff'
                                        }}
                                    >
                                        <AllInclusive />
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontWeight: '300', 
                                            color: '#fff',
                                            textAlign: 'right',
                                            fontSize: '16px',
                                            letterSpacing: '0px',
                                            opacity: '1'
                                        }}
                                        variant="subtitle1"
                                        color="#fff">
                                        Credits Remaining
                                    </Typography>
                                </Box>

                            </Paper>
                        </Grid>
                        <Grid item xl={2} lg={2} md={3} sm={6} xs={12}>
                            <Paper
                                elevation={5}
                                sx={{
                                    height: '120px',
                                    marginBottom: '25px',
                                    overflow: 'hidden',
                                    display: 'block',
                                    position: 'relative',
                                    flexGrow: '1',
                                    color: '#fff',
                                    backgroundColor: '#C49F47'
                                }}
                            >
                                <Box 
                                    component="div" 
                                    sx={{
                                        diplay: 'block', 
                                        width: '80px', 
                                        height: '80px',
                                        display: 'block',
                                        float: 'left',
                                        paddingLeft: '15px',
                                        paddingTop: '35px',
                                        marginBottom: '40px',
                                        fontSize: '35px',
                                        lineHeight: '35px'
                                        }}>
                                    <TieIcon
                                        sx={{
                                            color: '#fff',
                                            opacity: '0.1',
                                            fontSize: '110px',
                                            marginLeft: '-35px',
                                            lineHeight: '110px'
                                        }}/>
                                </Box>
                                <Box component="div" sx={{
                                    display: 'block',
                                    position: 'absolute',
                                    right: '15px',
                                    paddingRight: '15px',
                                }}>
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                paddingTop: '25px',
                                                textAlign: 'right',
                                                fontWeight: '300', 
                                                fontSize: '34px', 
                                                lineHeight: '36px',
                                                letterSpacing: '-1px',
                                                marginBottom: '0px',
                                                color: '#fff'
                                            }}
                                        >
                                            {props.total}
                                        </Typography>
                                        <Typography
                                            sx={{
                                                fontWeight: '300', 
                                                color: '#fff',
                                                textAlign: 'right',
                                                fontSize: '16px',
                                                letterSpacing: '0px',
                                                opacity: '1'
                                            }}
                                            variant="subtitle1"
                                            color="#fff"
                                        >
                                            Super Resellers
                                        </Typography>
                                </Box>

                            </Paper>
                        </Grid>
                        <Grid item xl={2} lg={2} md={3} sm={6} xs={12}>
                            <Paper
                                elevation={5}
                                sx={{
                                    height: '120px',
                                    marginBottom: '25px',
                                    overflow: 'hidden',
                                    display: 'block',
                                    position: 'relative',
                                    flexGrow: '1',
                                    color: '#fff',
                                    backgroundColor: '#3598DC'
                                }}
                            >
                                <Box 
                                    component="div" 
                                    sx={{
                                        diplay: 'block', 
                                        width: '80px', 
                                        height: '80px',
                                        display: 'block',
                                        float: 'left',
                                        paddingLeft: '15px',
                                        paddingTop: '35px',
                                        marginBottom: '40px',
                                        fontSize: '35px',
                                        lineHeight: '35px'
                                        }}>
                                    <PersonIcon
                                        sx={{
                                            color: '#fff',
                                            opacity: '0.1',
                                            fontSize: '110px',
                                            marginLeft: '-35px',
                                            lineHeight: '110px'
                                        }}/>
                                </Box>
                                <Box component="div" sx={{
                                    display: 'block',
                                    position: 'absolute',
                                    right: '15px',
                                    paddingRight: '15px',
                                }}>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            paddingTop: '25px',
                                            textAlign: 'right',
                                            fontWeight: '300', 
                                            fontSize: '34px', 
                                            lineHeight: '36px',
                                            letterSpacing: '-1px',
                                            marginBottom: '0px',
                                            color: '#fff'
                                        }}
                                    >
                                        {props.total_resellers}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontWeight: '300', 
                                            color: '#fff',
                                            textAlign: 'right',
                                            fontSize: '16px',
                                            letterSpacing: '0px',
                                            opacity: '1'
                                        }}
                                        variant="subtitle1"
                                        color="#fff"
                                    >
                                        Resellers
                                    </Typography>
                                </Box>

                            </Paper>
                        </Grid>
                        <Grid item xl={2} lg={2} md={3} sm={6} xs={12}>
                            <Paper
                                elevation={5}
                                sx={{
                                    height: '120px',
                                    marginBottom: '25px',
                                    overflow: 'hidden',
                                    display: 'block',
                                    position: 'relative',
                                    flexGrow: '1',
                                    color: '#fff',
                                    backgroundColor: '#9A12B3'
                                }}
                            >
                                <Box component="div" 
                                    sx={{
                                        diplay: 'block', 
                                        width: '80px', 
                                        height: '80px',
                                        display: 'block',
                                        float: 'left',
                                        paddingLeft: '15px',
                                        paddingTop: '35px',
                                        marginBottom: '40px',
                                        fontSize: '35px',
                                        lineHeight: '35px'
                                        }}>
                                    <SupervisorAccountIcon
                                        sx={{
                                            color: '#fff',
                                            opacity: '0.1',
                                            fontSize: '110px',
                                            marginLeft: '-35px',
                                            lineHeight: '110px'
                                        }}/>
                                </Box>
                                <Box component="div" sx={{
                                    display: 'block',
                                    position: 'absolute',
                                    right: '15px',
                                    paddingRight: '15px',
                                }}>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            paddingTop: '25px',
                                            textAlign: 'right',
                                            fontWeight: '300', 
                                            fontSize: '34px', 
                                            lineHeight: '36px',
                                            letterSpacing: '-1px',
                                            marginBottom: '0px',
                                            color: '#fff'
                                        }}
                                    >
                                        {props.total_dealers}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontWeight: '300', 
                                            color: '#fff',
                                            textAlign: 'right',
                                            fontSize: '16px',
                                            letterSpacing: '0px',
                                            opacity: '1'
                                        }}
                                        variant="subtitle1"
                                        color="#fff"
                                    >
                                        Dealers
                                    </Typography>
                                </Box>

                            </Paper>
                        </Grid>
                        <Grid item xl={2} lg={2} md={3} sm={6} xs={12}>
                            <Paper
                                elevation={5}
                                sx={{
                                    height: '120px',
                                    marginBottom: '25px',
                                    overflow: 'hidden',
                                    display: 'block',
                                    position: 'relative',
                                    flexGrow: '1',
                                    color: '#fff',
                                    backgroundColor: '#4B77BE'
                                }}
                            >
                                <Box component="div" 
                                    sx={{
                                        diplay: 'block', 
                                        width: '80px', 
                                        height: '80px',
                                        display: 'block',
                                        float: 'left',
                                        paddingLeft: '15px',
                                        paddingTop: '35px',
                                        marginBottom: '40px',
                                        fontSize: '35px',
                                        lineHeight: '35px'
                                        }}>
                                    <UsersIcon
                                        sx={{
                                            color: '#fff',
                                            opacity: '0.1',
                                            fontSize: '110px',
                                            marginLeft: '-35px',
                                            lineHeight: '110px'
                                        }}/>
                                </Box>
                                <Box component="div" sx={{
                                    display: 'block',
                                    position: 'absolute',
                                    right: '15px',
                                    paddingRight: '15px',
                                }}>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            paddingTop: '25px',
                                            textAlign: 'right',
                                            fontWeight: '300', 
                                            fontSize: '34px', 
                                            lineHeight: '36px',
                                            letterSpacing: '-1px',
                                            marginBottom: '0px',
                                            color: '#fff'
                                        }}
                                    >
                                        {props.total_all_clients}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontWeight: '300', 
                                            color: '#fff',
                                            textAlign: 'right',
                                            fontSize: '16px',
                                            letterSpacing: '0px',
                                            opacity: '1'
                                        }}
                                        variant="subtitle1"
                                        color="#fff"
                                    >
                                        All Users
                                    </Typography>
                                </Box>

                            </Paper>
                        </Grid>
                        <Grid item xl={2} lg={2} md={3} sm={6} xs={12}>
                            <Paper
                                elevation={5}
                                sx={{
                                    height: '120px',
                                    marginBottom: '25px',
                                    overflow: 'hidden',
                                    display: 'block',
                                    position: 'relative',
                                    flexGrow: '1',
                                    color: '#fff',
                                    backgroundColor: '#26C281'
                                }}
                            >
                                <Box component="div" 
                                    sx={{
                                        diplay: 'block', 
                                        width: '80px', 
                                        height: '80px',
                                        display: 'block',
                                        float: 'left',
                                        paddingLeft: '15px',
                                        paddingTop: '35px',
                                        marginBottom: '40px',
                                        fontSize: '35px',
                                        lineHeight: '35px'
                                        }}>
                                    <HowToReg
                                        sx={{
                                            color: '#fff',
                                            opacity: '0.1',
                                            fontSize: '110px',
                                            marginLeft: '-35px',
                                            lineHeight: '110px'
                                        }}/>
                                </Box>
                                <Box component="div" sx={{
                                    display: 'block',
                                    position: 'absolute',
                                    right: '15px',
                                    paddingRight: '15px',
                                }}>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            paddingTop: '25px',
                                            textAlign: 'right',
                                            fontWeight: '300', 
                                            fontSize: '34px', 
                                            lineHeight: '36px',
                                            letterSpacing: '-1px',
                                            marginBottom: '0px',
                                            color: '#fff'
                                        }}
                                    >
                                        {props.total_active_clients}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontWeight: '300', 
                                            color: '#fff',
                                            textAlign: 'right',
                                            fontSize: '16px',
                                            letterSpacing: '0px',
                                            opacity: '1'
                                        }}
                                        variant="subtitle1"
                                        color="#fff"
                                    >
                                        Active Users
                                    </Typography>
                                </Box>

                            </Paper>
                        </Grid>
                        <Grid item xl={2} lg={2} md={3} sm={6} xs={12}>
                            <Paper
                                elevation={5}
                                sx={{
                                    height: '120px',
                                    marginBottom: '25px',
                                    overflow: 'hidden',
                                    display: 'block',
                                    position: 'relative',
                                    flexGrow: '1',
                                    color: '#fff',
                                    backgroundColor: '#D91E18'
                                }}
                            >
                                <Box component="div" 
                                    sx={{
                                        diplay: 'block', 
                                        width: '80px', 
                                        height: '80px',
                                        display: 'block',
                                        float: 'left',
                                        paddingLeft: '15px',
                                        paddingTop: '35px',
                                        marginBottom: '40px',
                                        fontSize: '35px',
                                        lineHeight: '35px'
                                        }}>
                                    <PersonOffIcon
                                        sx={{
                                            color: '#fff',
                                            opacity: '0.1',
                                            fontSize: '110px',
                                            marginLeft: '-35px',
                                            lineHeight: '110px'
                                        }}/>
                                </Box>
                                <Box component="div" sx={{
                                    display: 'block',
                                    position: 'absolute',
                                    right: '15px',
                                    paddingRight: '15px',
                                }}>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            paddingTop: '25px',
                                            textAlign: 'right',
                                            fontWeight: '300', 
                                            fontSize: '34px', 
                                            lineHeight: '36px',
                                            letterSpacing: '-1px',
                                            marginBottom: '0px',
                                            color: '#fff'
                                        }}
                                    >
                                        {props.total_expired_clients}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontWeight: '300', 
                                            color: '#fff',
                                            textAlign: 'right',
                                            fontSize: '16px',
                                            letterSpacing: '0px',
                                            opacity: '1'
                                        }}
                                        variant="subtitle1"
                                        color="#fff"
                                    >
                                        Expired Users
                                    </Typography>
                                </Box>

                            </Paper>
                        </Grid>
                        <Grid item xl={2} lg={2} md={3} sm={6} xs={12}>
                            <Paper
                                elevation={5}
                                sx={{
                                    height: '120px',
                                    marginBottom: '25px',
                                    overflow: 'hidden',
                                    display: 'block',
                                    position: 'relative',
                                    flexGrow: '1',
                                    color: '#fff',
                                    backgroundColor: '#95950A'
                                }}
                            >
                                <Box component="div" 
                                    sx={{
                                        diplay: 'block', 
                                        width: '80px', 
                                        height: '80px',
                                        display: 'block',
                                        float: 'left',
                                        paddingLeft: '15px',
                                        paddingTop: '35px',
                                        marginBottom: '40px',
                                        fontSize: '35px',
                                        lineHeight: '35px'
                                        }}>
                                    <TrialIcon
                                        sx={{
                                            color: '#fff',
                                            opacity: '0.1',
                                            fontSize: '110px',
                                            marginLeft: '-35px',
                                            lineHeight: '110px'
                                        }}
                                    />
                                </Box>
                                <Box component="div" sx={{
                                    display: 'block',
                                    position: 'absolute',
                                    right: '15px',
                                    paddingRight: '15px',
                                }}>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            paddingTop: '25px',
                                            textAlign: 'right',
                                            fontWeight: '300', 
                                            fontSize: '34px', 
                                            lineHeight: '36px',
                                            letterSpacing: '-1px',
                                            marginBottom: '0px',
                                            color: '#fff'
                                        }}
                                    >
                                        {props.total_trials}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontWeight: '300', 
                                            color: '#fff',
                                            textAlign: 'right',
                                            fontSize: '16px',
                                            letterSpacing: '0px',
                                            opacity: '1'
                                        }}
                                        variant="subtitle1"
                                        color="#fff"
                                    >
                                        Trials
                                    </Typography>
                                </Box>

                            </Paper>
                        </Grid>

                        <Grid item xl={2} lg={2} md={3} sm={6} xs={12}>
                            <Paper
                                elevation={5}
                                sx={{
                                    height: '120px',
                                    marginBottom: '25px',
                                    overflow: 'hidden',
                                    display: 'block',
                                    position: 'relative',
                                    flexGrow: '1',
                                    color: '#fff',
                                    backgroundColor: '#4B123E' //75, 18, 62
                                }}
                            >
                                <Box component="div" 
                                    sx={{
                                        diplay: 'block', 
                                        width: '80px', 
                                        height: '80px',
                                        display: 'block',
                                        float: 'left',
                                        paddingLeft: '15px',
                                        paddingTop: '35px',
                                        marginBottom: '40px',
                                        fontSize: '35px',
                                        lineHeight: '35px'
                                        }}>
                                    <MinistraIcon
                                        sx={{
                                            color: '#fff',
                                            opacity: '0.1',
                                            fontSize: '110px',
                                            marginLeft: '-35px',
                                            lineHeight: '110px'
                                        }}/>
                                </Box>
                                <Box component="div" sx={{
                                    display: 'block',
                                    position: 'absolute',
                                    right: '15px',
                                    paddingRight: '15px',
                                }}>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            paddingTop: '25px',
                                            textAlign: 'right',
                                            fontWeight: '300', 
                                            fontSize: '34px', 
                                            lineHeight: '36px',
                                            letterSpacing: '-1px',
                                            marginBottom: '0px',
                                            color: '#fff'
                                        }}
                                    >
                                        {props.total_ministra}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontWeight: '300', 
                                            color: '#fff',
                                            textAlign: 'right',
                                            fontSize: '16px',
                                            letterSpacing: '0px',
                                            opacity: '1'
                                        }}
                                        variant="subtitle1"
                                        color="#fff"
                                    >
                                        Ministra
                                    </Typography>
                                </Box>
                            </Paper>
                        </Grid>   
                    </Grid>
                    <Grid item xl={9} lg={12} md={12} sm={12} xs={12}>
                                <TotalsChart role="admin" />
                    </Grid>
            </Grid>        
        </Container>
    );
}

// </Container>

                        

// </div>
// </div>
const mapDispatchToProps = dispatch => {
    return {
        onGetSuperResellerList: (token) => dispatch(actions.superResellerList(token)),
        onInitializeSaveMessage: () => dispatch(actions.initializeSaveMessage()),
        onGetCountResellers: (token) => dispatch(actions.countResellersAdmin(token)),
        onGetCountDealers: (token) => dispatch(actions.countDealersAdmin(token)),
        onGetCountAllClients: (token) => dispatch(actions.countAllClientsAdmin(token)),
        onGetCountActiveClients: (token) => dispatch(actions.countActiveClientsAdmin(token)),
        onGetCountExpiredClients: (token) => dispatch(actions.countExpiredClientsAdmin(token)),
        onGetCountTrials: (token) => dispatch(actions.countTrialsAdmin(token)),
        onGetCountMinistra: (token) => dispatch(actions.countMinistraAdmin(token)),
        onGetCountActiveTickets: (token) => dispatch(actions.getActiveTicketsAdmin(token))
    }
};

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        total: state.superResellers.total,
        total_resellers: state.countResellers.total,
        total_dealers: state.countDealers.total,
        total_all_clients: state.countAllClients.total,
        total_active_clients: state.countActiveClients.total,
        total_expired_clients: state.countExpiredClients.total,
        total_trials: state.countTrials.total,
        total_ministra: state.countMinistra.total,
        total_active_tickets: state.countActiveTickets.total
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ResellerDashboard);